// UI:
import 'bootstrap-less'; // globally import bootstrap UI framework
// polyfills:
import 'core-js/stable'; // babel transforms this to only few required polyfills based on targeted browsers (this does not include whole lib)
// portaro FE entrypoint
import './portaro';